var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"credentialsBox"},[_c('div',{staticClass:"credentialsHeader"},[_vm._v(_vm._s(_vm.credentialsData.credentialsName))]),_c('div',{staticClass:"imgBox"},[_c('img',{staticClass:"credentialsImg",attrs:{"src":_vm.credentialsData.imgUrl,"alt":_vm.credentialsData.credentialsName}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }